import { DomainError, unknownErrorToError } from '@w/utils'
import { useTranslation } from '../i18n'

// oxlint-disable-next-line typescript/no-redundant-type-constituents -- unknown | null is intentional for error boundary API
export function useErrorBoundaryDomain(unknownError: unknown | null): {
  error?: Error
  domainText?: string
} {
  const { t } = useTranslation('ui')

  const error = (unknownError === null || unknownError === undefined) ? undefined : unknownErrorToError(unknownError)

  const getTrpcDomainUserMessage = (
    value: unknown,
  ): { key: string; params?: Record<string, unknown> } | undefined => {
    if (!value || typeof value !== 'object') return undefined
    const data = (value as { data?: unknown }).data
    if (!data || typeof data !== 'object') return undefined
    const de = (data as { domainError?: unknown }).domainError
    if (!de || typeof de !== 'object') return undefined
    const userMessage = (de as { userMessage?: unknown }).userMessage
    if (!Array.isArray(userMessage)) return undefined
    // oxlint-disable-next-line typescript/no-unsafe-assignment -- userMessage is any[] from unknown error shape
    const [key, params] = userMessage
    if (typeof key !== 'string') return undefined
    const paramsObj =
      params && typeof params === 'object'
        ? (params as Record<string, unknown>)
        : undefined
    return { key, params: paramsObj }
  }

  const getDomainUserMessage = (
    value: unknown,
  ): { key: string; params?: Record<string, unknown> } | undefined => {
    if (value instanceof DomainError) {
      const parts = value.userMessage || []
      const key = typeof parts[0] === 'string' ? parts[0] : undefined
      if (!key) return undefined
      const params =
        parts[1] && typeof parts[1] === 'object'
          ? (parts[1] as Record<string, unknown>)
          : undefined
      return { key, params }
    }
    return getTrpcDomainUserMessage(value)
  }

  const domainText = (() => {
    const msg = getDomainUserMessage(unknownError)
    // oxlint-disable-next-line unicorn/no-useless-undefined -- required for consistent-return: other branch returns a value
    if (!msg) return undefined
    // oxlint-disable-next-line typescript/no-explicit-any, typescript/no-unsafe-argument -- we don't know error message key type
    return t(msg.key as any, msg.params as any)
  })()

  return { error, domainText }
}

